import React from 'react';

import {withStyles, Typography, Button} from '@material-ui/core';
import styles from '../config/styles';
import inventory from '../data/inventory';

class Community extends React.Component{
    render(){
        const {classes} = this.props;
        return(
            <section className={[classes.section, classes.greySection].join(" ")}>
                <div className={classes.innerBox}>
                    <div className={classes.innerHeaderSection}>
                        <Typography variant="h4">
                            Community
                        </Typography>
                        <Typography variant="subtitle1">
                            We strongly belive in giving back to the community as we grow. We are opening our tricks and tools of the trade to anyone who want to bulid great products.
                        </Typography>
                        <Button variant="outlined" color="primary" size="large" style={{marginTop: "2em"}}href="mailto:hello@ftlabs.io?Subject=Hello" target="_top">Contact Us</Button>
                    </div>
                    <div className={classes.innerDetailSection}>
                        <div className={classes.inventoryContainer}>
                        {
                            inventory.map(function(item){
                                return(
                                    <div className={classes.inventoryItem} xs={6} sm={6} md={4} lg={4} key={item.title}>
                                        <div className={classes.inventoryIconContainer}>
                                            <img src={item.icon} className={classes.inventoryIcon} alt={item.title}  />    
                                        </div>
                                        <Typography variant="subtitle1">{item.title}</Typography>
                                        {/* <Typography variant="subheading">{item.tagline}</Typography> */}
                                    </div>
                                )
                            })
                        }
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default withStyles(styles)(Community);